<div class="all" mat-dialog-content style="padding: 0 6vw">
  <lemon-dialog-header [naytaSuljeRuksi]="false" [naytaOtsikko]="false"></lemon-dialog-header>
  <div class="big-card">
    <div class="red-text title-text" [innerHTML]="'holvi-oauth.failed.virhe' | translate | async"></div>

    <div class="inner-container red-text">
      <div>{{ 'holvi-oauth.failed.yhdistely-epaonnistui' | translate | async }}</div>
    </div>
    <div class="button-container">
      <button class="primarybutton" (click)="sulje()" mat-button>{{ 'yleiset.jatka' | translate | async }}</button>
    </div>
  </div>
</div>
